module.exports = __webpack_public_path__ + "img/intro1.fcd05c6c.png";